import { Injectable } from '@angular/core';
@Injectable()
export class GridResultService {
  gridResult: string = null;

  GridresultType(rtype: string) {
    
    this.gridResult = rtype;
  };

}
